module.exports = __webpack_public_path__ + "img/badge_dmain.168ae858.png";